module.exports = __webpack_public_path__ + "img/livinghead_icon01.7b7e016e.png";